import { createContext, useContext } from "react";

export const ProcessingContext = createContext({
  isProcessing: false,
  setProcessing: (_: boolean) => {},
});
export const useProcessingContext = () => useContext(ProcessingContext);
